/** Amount display: always 2 decimals, en-US thousands separator. */
export function formatMoneyAmount(num: unknown): string {
  if (num === null || num === undefined || num === '') {
    return ''
  }
  const value = Number(num)
  if (Number.isNaN(value)) {
    return String(num)
  }
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

/** Example: "$ 0.19" or "USD 1,234.56" */
export function formatMoneyWithSymbol(symbol: string | null | undefined, num: unknown): string {
  const amount = formatMoneyAmount(num)
  const prefix = (symbol || '').trim()
  if (!prefix) {
    return amount
  }
  if (!amount) {
    return prefix
  }
  return `${prefix} ${amount}`
}
